import React from 'react';
import { cookieGetValue } from 'hooks/useCookie';

const buildFormUrl = (campaign) => {
  let url = campaign.formUrl;
  if (campaign.emailEntryId) {
    const email = cookieGetValue('teespring_user_email');
    if (email && email !== 'unknown') {
      const separator = url.includes('?') ? '&' : '?';
      url = `${url}${separator}entry.${
        campaign.emailEntryId
      }=${encodeURIComponent(email)}`;
    }
  }
  return url;
};

const MarketingPopupEmbedForm = ({ campaign }) => {
  return (
    <div className='marketing-popup__embed-form'>
      <iframe
        src={buildFormUrl(campaign)}
        title={campaign.title}
        height={campaign.iframeHeight || '400px'}
        style={
          campaign.iframeOffsetTop
            ? { marginTop: campaign.iframeOffsetTop }
            : undefined
        }
        sandbox='allow-forms allow-scripts allow-same-origin allow-popups'
      />
    </div>
  );
};

export default MarketingPopupEmbedForm;
